import { render, staticRenderFns } from "./DropFile.vue?vue&type=template&id=6c4cde7a"
import script from "./DropFile.vue?vue&type=script&lang=js"
export * from "./DropFile.vue?vue&type=script&lang=js"
import style0 from "./DropFile.vue?vue&type=style&index=0&id=6c4cde7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports